//@vendor
const Immutable = require('immutable');
//@constants
const { DATE_FORMAT_API } = require('constants/index');
const actionTypes = require('constants/actionTypes');

const moment = require('moment');
const today = moment().startOf('day');
const {
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED,
  } = require('constants/index');
    // @utilities
const { hash } = require('utilities/hash');

const initialState = Immutable.fromJS({
    accessFrom: '',
    selectedOption: null,
    selectedContract: null,
    stateOperation: BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED,
    isCheckContributions: false,
    isCheckSubscription: false,
    isCheckReimbursement: false,
    isCheckTransfer: false,
    dateForFilter: {
        selected: today,
        from: moment().startOf('day').year(2005).format(DATE_FORMAT_API),
        to: today.format(DATE_FORMAT_API)
    },
    fetchingContractList: false,
    errorContractList: false,
    successContractList: false,
    contractList: null,
    cryptoContractList: null,
    fetchingCryptoContractList: false,
    errorCryptoContractList: false,
    successCryptoContractList: false,
});

const buildId = dataList => {
    return dataList.map(fund => {
      return {
        ...fund,
        id: hash([fund.walletNumber, null]),
        disabled: false,
        value: hash([fund.walletNumber, null]),
      };
    });
  };

  const buildWalletBalance = (contractList, listContractFromPG) => {
    const newData = contractList.map(fund => {
      if (listContractFromPG.byId[fund.id]) {
        const balanceFromPG = listContractFromPG.byId[fund.id];
        return {
          ...fund,
          walletBalance: {
            amount: balanceFromPG?.walletBalance?.amount,
            currency: balanceFromPG?.walletBalance?.currency,
          },
        };
      } else {
        return {
          ...fund,
          walletBalance: {
            amount: '-',
            currency: '',
          },
        };
      }
    });
    return newData;
  };

  const buildContractList = (contracts, listContractFromPG) => {
    const { funds, plans, values, crypto } = contracts;
    let fundList = funds ? buildId(funds) : [];
    let planList = plans ? buildId(plans) : [];
    let valuesList = values ? buildId(values) : [];
    let cryptoList = crypto ? buildId(crypto) : [];

    fundList = buildWalletBalance(fundList, listContractFromPG);
    planList = buildWalletBalance(planList, listContractFromPG);
    valuesList = buildWalletBalance(valuesList, listContractFromPG);

    return {
        funds: fundList,
        plans: planList,
        values: valuesList,
        crypto: cryptoList
    };
  };

function brokerOrdersAndMovements(state = initialState, action) {
    switch (action.type) {
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_ACCESS_FROM:
            return state.merge({
                accessFrom: action.payload.type
            });
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SELECTED_OPTION_CHANGED:
            return state.merge({
                selectedOption: action.payload.selectedOption
            });
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_CONTRACT_NUMBER:
            return state.merge({
                selectedContract: action.payload.selectedContract
            });
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_RESET:
            return initialState;
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_STATE_OPERATIONS_FILTER:
            return state.merge({
                stateOperation: action.payload
            })
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_IS_CHECK_CONTRIBUTIONS:
            return state.merge({
                isCheckContributions: action.payload
            })
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_IS_CHECK_SUBSCRIPTION:
            return state.merge({
                isCheckSubscription: action.payload
            })
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_IS_CHECK_REIMBURSEMENT:
            return state.merge({
                isCheckReimbursement: action.payload
            })
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_IS_CHECK_TRANSFER:
            return state.merge({
                isCheckTransfer: action.payload
            })
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET__MAX_DATE:
            return state.setIn(['dateForFilter', 'to'], action.payload.format(DATE_FORMAT_API))
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET__MIN_DATE:
            return state.setIn(['dateForFilter', 'from'], action.payload.format(DATE_FORMAT_API))
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_GET_CONTRACT_LIST_FETCHING:
            return state.merge({
                fetchingContractList: true,
                errorContractList: false,
                successContractList: false,
            })
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_GET_CONTRACT_LIST_SUCCESS:
            const contractList = buildContractList(action.payload, action.listContractFromPG);
            return state.merge({
                fetchingContractList: false,
                errorContractList: false,
                successContractList: true,
                contractList: contractList,
            })
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_GET_CONTRACT_LIST_FAILURE:
            return state.merge({
                fetchingContractList: false,
                errorContractList: true,
                successContractList: false,
                contractList: null,
            })
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_GET_CRYPTO_CONTRACT_REQUEST:
            return state.merge({
                fetchingCryptoContractList: true,
                errorCryptoContractList: false,
                successCryptoContractList: false,
                cryptoContractList: null,
            });
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_GET_CRYPTO_CONTRACT_SUCCESS:
            const cryptoContractList = buildContractList(action.payload.response, action.payload.listContractFromPG);
            return state.merge({
                fetchingCryptoContractList: false,
                errorCryptoContractList: false,
                successCryptoContractList: true,
                cryptoContractList: cryptoContractList.crypto,
            });
        case actionTypes.BROKER_ORDERS_AND_MOVEMENTS_GET_CRYPTO_CONTRACT_FAILURE:
            return state.merge({
                fetchingCryptoContractList: false,
                errorCryptoContractList: true,
                successCryptoContractList: false,
                cryptoContractList: null,
            });
        default:
            return state;
    }
}

module.exports = brokerOrdersAndMovements;
